export default __webpack_public_path__ + "static/media/fallbackicon_large.5119b649.svg";